import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Main, Results, QuantityOfProducts, SelectedArrow, QuantitySelectedOfProducts, QuantitySelectedOfProductsIcon, OptionSelectHitsPerPage,
} from './styled'
import SelectorHitsPerPageModal from './SelectorHitsPerPageModal'

const renderOptionSelect = (setHitsPerPage, setShowModal, hitsPerPage, optionsHitPerPage) => (
  <div style={{ margin: '20px' }}>
    <OptionSelectHitsPerPage>
      Número de productos por página
    </OptionSelectHitsPerPage>
    {optionsHitPerPage
      .map((item) => {
        const isActive = item === hitsPerPage
        return (
          <QuantitySelectedOfProducts
            className="quantity-selected-of-products"
            data-testid="QuantitySelectedOfProducts-test-renderer"
            key={item}
            onClick={() => {
              setHitsPerPage(item)
              setShowModal(false)
            }}
            onKeyPress={() => {
              setHitsPerPage(item)
              setShowModal(false)
            }}
            isActive={isActive}
          >
            {item}
            {' '}
            productos
            {isActive && (
              <QuantitySelectedOfProductsIcon
                alt="white-arrow"
                src="/catalogo/images/arrow_down.svg"
              />
            )}
          </QuantitySelectedOfProducts>
        )
      })}

  </div>
)


const QuantityProductsShown = ({
  productsFound, hitsPerPage, setHitsPerPage, optionsHitPerPage,
}) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <Main>
      <Results>
        {productsFound}
        {' '}
        resultados
      </Results>
      <div style={{ color: '#414042' }}> | </div>
      <QuantityOfProducts
        className="quantity-of-products"
        data-testid="QuantityOfProducts-test-renderer"
        onClick={() => setShowModal(true)}
        onKeyPress={() => setShowModal(true)}
      >
        {hitsPerPage}
        {' '}
        productos
        <SelectedArrow
          style={{ marginLeft: '10px' }}
          alt="white-arrow"
          src="/catalogo/images/arrow_down.svg"
        />
      </QuantityOfProducts>

      <SelectorHitsPerPageModal
        modalIsOpen={showModal}
        setShowModal={setShowModal}
      >
        {renderOptionSelect(setHitsPerPage, setShowModal, hitsPerPage, optionsHitPerPage)}
      </SelectorHitsPerPageModal>
    </Main>
  )
}

QuantityProductsShown.propTypes = {
  hitsPerPage: PropTypes.number.isRequired,
  productsFound: PropTypes.number.isRequired,
  setHitsPerPage: PropTypes.func.isRequired,
  optionsHitPerPage: PropTypes.array.isRequired,
}

export default QuantityProductsShown
